import { PageHeader } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Session, Utilitaries } from "../../../business";
import { sendHttpRequest } from "../../../components/http.request";
import { FormRender } from "../../components/FormRender";
import { GenericObject } from "../../types/common";

interface Props {
    form_name?: string;
    form_id?: string;
    popup_params?: GenericObject;
    onSave: (value?: string) => void;
    setJustSeePopup?: (justSeePopup: boolean) => void;
    justSee?: boolean;
    isInModal: boolean;
}

interface ParamProps {
    name: string;
    id: string;
}

export function MenuFormRender({
    form_name,
    form_id,
    popup_params,
    onSave,
    justSee,
    setJustSeePopup,
    isInModal = false,
}: Props) {
    const { name, id } = useParams<ParamProps>();

    const form_key = form_name || name || "";
    const browserHistory = useHistory();

    const [objForm, setFormObj] = useState({
        form: {},
        loading: false,
        formTitle: null,
    });

    const { form, formTitle, loading } = objForm;

    console.log("onSave", onSave);

    const getForm = useCallback(async () => {
        try {
            setFormObj((state) => ({
                ...state,
                form: {},
                loading: true,
            }));
            const _formData = new FormData();

            _formData.append("utilizador", Session.getUsername());

            _formData.append("accao", "dados");
            let formID = "";
            // se menu enviar 0
            // se popup enviar vazio para novo e id para editar
            if (form_id && isInModal) {
                formID = form_id;
            } else if (id && !isInModal) {
                formID = id;
            } else if (form_name) {
                formID = "";
            } else {
                formID = "0";
            }
            _formData.append("id", formID);

            if (!Utilitaries.isEmpty(popup_params) && popup_params) {
                Object.keys(popup_params).forEach((el) => {
                    if (!_formData.has(el)) {
                        _formData.append(el, popup_params[el]);
                    }
                });
            }

            _formData.append("hack", "true");
            _formData.append("formulario", form_key);

            const { formulario, result } = await sendHttpRequest("POST", "/Gestor/gereformulario.php", _formData);
            let formBody = {
                form: null,
                values: null,
            };

            formBody = {
                form: formulario || result?.formulario,
                values: result?.valores || null,
            };

            const rootElement = formBody.form?.["@elemento_raiz"];

            if (setJustSeePopup) {
                const formReadOnly = formBody.form?.[rootElement!]?.["@consulta_formulario"] === "sim" ? true : justSee;
                setJustSeePopup(formReadOnly || false);
            }

            setFormObj({
                loading: false,
                form: formBody,
                formTitle: !isInModal ? formBody.form?.[rootElement!]?.["@titulo"] ?? null : null,
            });
        } catch (error) {
            setFormObj({
                loading: false,
                form: {},
                formTitle: null,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form_id, form_key]);

    useEffect(() => {
        getForm();
    }, [getForm]);

    function onSaveForm(value?: string) {
        console.log("on Saving form ....");
        if (onSave) { 
            onSave(value);
        }

        if (!isInModal) {
            getForm();
        }
    }

    return (
        <>
            {!isInModal && <PageHeader onBack={() => browserHistory.goBack()} title={formTitle} />}
            <FormRender
                loadForm={loading}
                form={form}
                popup_params={popup_params}
                onSave={onSaveForm}
                justSee={justSee}
                isInModal={isInModal}
            />
        </>
    );
}
